import { styled } from '@mui/material/styles';

export const StyledHeader = styled('div')`
    position: fixed;
    top: 0;
    right: 2%;
    width: 100%;
    display: flex;
    justify-content: end;
    height: 80px;
    z-index: 9;
    align-items: center;
    background-color: white;
`;